import React, {Component} from 'react';
import {Button} from 'react-bootstrap';
import Utils from "./Utils";

export default class FrameworkContractArticle extends Component {
    constructor() {
        super();

        this.state = {
            key: 0,
            title: "",
            amount: "",
            amount_vat: ""
        };

        this.removeItem = this.removeItem.bind(this);
        this.handleTitleChange = this.handleTitleChange.bind(this);
        this.handleAmountChange = this.handleAmountChange.bind(this);
        this.handleAmountVatChange = this.handleAmountVatChange.bind(this);
    }

    componentWillMount() {
        let article = this.props.article;
        this.setState({
            key: article.key,
            title: article.article_title,
            amount: article.article_amount_comma,
            amount_vat: article.article_amount_vat_comma,
        });
    }

    handleTitleChange(e) {
        this.setState({title: e.target.value});
    }

    handleAmountChange(e) {
        let value = Utils.handleDecimals(e.target.value);
        let amount = parseFloat(value.replace(",", "."));
        let amount_vat = this.state.amount_vat;
        if (!isNaN(amount)) {
            amount_vat = 1.24 * amount;
            amount_vat = Utils.precision_round(amount_vat, 2);
            amount_vat = amount_vat + "";
            amount_vat = amount_vat.replace(".", ",");
        }

        this.setState({
            amount: value,
            amount_vat: amount_vat
        });
    }

    handleAmountVatChange(e) {
        let value = Utils.handleDecimals(e.target.value);
        let amount_vat = parseFloat(value.replace(",", "."));
        let amount = this.state.amount;
        if (!isNaN(amount_vat)) {
            amount = amount_vat / 1.24;
            amount = Utils.precision_round(amount, 2);
            amount = amount + "";
            amount = amount.replace(".", ",");
        }

        this.setState({
            amount: amount,
            amount_vat: value
        });
    }

    removeItem() {
        this.props.removeFn(this.state.key);
    }

    render() {
        return (
            <tr>
                <td>
                    <input type="text"
                           name={"articles[" + this.state.key + "][article_title]"}
                           value={this.state.title}
                           className="form-control"
                           onChange={this.handleTitleChange}/>
                </td>
                <td>
                    <input type="text"
                           name={"articles[" + this.state.key + "][article_amount_comma]"}
                           value={this.state.amount}
                           className="form-control"
                           onChange={this.handleAmountChange}/>
                </td>
                <td>
                    <input type="text"
                           name={"articles[" + this.state.key + "][article_amount_vat_comma]"}
                           value={this.state.amount_vat}
                           className="form-control"
                           onChange={this.handleAmountVatChange}/>
                </td>
                <td>
                    <Button onClick={this.removeItem}
                            bsStyle="danger">
                        <i className="fa fa-minus"></i>
                    </Button>
                </td>
            </tr>
        );
    }
}